import { render, staticRenderFns } from "./OAuthLogoutView.vue?vue&type=template&id=155a2eea&scoped=true&"
import script from "./OAuthLogoutView.vue?vue&type=script&lang=js&"
export * from "./OAuthLogoutView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155a2eea",
  null
  
)

export default component.exports